<div class="progress-dialog">
  <div class="progress-dialog__content">
    <div class="progress-dialog__spinner">
      <div class="progress-dialog__progress"></div>
    </div>
  </div>
</div>
